import { Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React, { useState } from "react";
import SlidingPanel from "react-sliding-side-panel";
import DatePicker from "../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddNewRequest: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [pageStatus, setPageStatus] = useState<number>(1);
  const [gender, setGender] = useState("Male");
  const [newgender, setNewGender] = useState("");
  const [employeenewname, setEmployeeNewName] = useState("");
  const [employeelastname, setEmployeeLastName] = useState("");
  const [employeename, setEmployeeName] = useState("Vikas Saini");
  const [clientid, setClientId] = useState("");
  const [endorsementType, setEndorsementType] = useState(
    "Non Commercial Endorsement"
  );
  const [endorsementTypeOne, setEndorsementTypeOne] = useState(
    "Commercial Endorsement"
  );
  const [type, setType] = useState("");
  const [email, setEmail] = useState("vikas.saini@evervent.in");
  const [newemail, setNewEmail] = useState("");
  const [employeeid, setEmployeeId] = useState("");
  const [selectPolicy, setSelectPolicy] = useState("");
  const [mobilenumber, setMobileNumber] = useState("9874563214");
  const [newmobilenumber, setNewMobileNumber] = useState("");
  const [Dob, setDob] = useState<Date | null>(new Date());
  const [newDob, setNewDob] = useState<Date | null>(null);
  const [address, setAddress] = useState(
    "Next57,341,phase 9, Industrial area Mohali, Punjab, India, 160062"
  );
  const [employeenewaddress, setEmployeeNewAddress] = useState("");
  const [areaName, setAreaName] = useState("");
  const [country, setCountry] = useState("");
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [Zipcode, setZipcode] = useState("");
  const [supportingDocument, setSupportingDocument] = useState("");
  const [file, setFile] = useState();
  function handleChange(event: any) {
    setFile(event.target.files[0]);
  }

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  const employee_id_data = [
    { key: "EV 3232- Vikas", value: "EV 3232- Vikas" },
    { key: "EV 3233- Vikas", value: "EV 3233- Vikas" },
    { key: "EV 3234- Vikas", value: "EV 3234- Vikas" },
    { key: "EV 3235- Vikas", value: "EV 3235- Vikas" },
    { key: "EV 3236- Vikas", value: "EV 3236- Vikas" },
    { key: "EV 3237- Vikas", value: "EV 3237- Vikas" },
  ];
  const policy_id_data = [
    { key: "123232- Vikas", value: "123232- Vikas" },
    { key: "123233- Vikas", value: "123233- Vikas" },
    { key: "123234- Vikas", value: "123234- Vikas" },
    { key: "123235- Vikas", value: "123235- Vikas" },
    { key: "123236- Vikas", value: "123236- Vikas" },
    { key: "123237- Vikas", value: "123237- Vikas" },
  ];
  const client_id_data = [
    { key: "EV 3232- Vikas Saini", value: "EV 3232- Vikas Saini" },
    { key: "EV 3233- Vikas Saini", value: "EV 3233- Vikas Saini" },
    { key: "EV 3234- Vikas Saini", value: "EV 3234- Vikas Saini" },
    { key: "EV 3235- Vikas Saini", value: "EV 3235- Vikas Saini" },
    { key: "EV 3236- Vikas Saini", value: "EV 3236- Vikas Saini" },
    { key: "EV 3237- Vikas Saini", value: "EV 3237- Vikas Saini" },
  ];
  const type_data = [
    { key: "Name", value: "Name" },
    { key: "Address", value: "Personal Address" },
    { key: "Mobile Number", value: "Contact Number" },
    { key: "Gender", value: "Gender" },
    { key: "Email", value: "Email" },
    { key: "Date of Birth", value: "Date of Birth" },
  ];
  const gender_data = [
    { key: "male", value: "Male" },
    { key: "female", value: "Female" },
  ];
  const supporting_document_data = [
    { key: "Aadhar", value: "Aadhar" },
    { key: "PanCard", value: "Pan Card" },
    { key: "DrivingLiscense", value: "Driving Liscense" },
    { key: "Passport", value: "Passport" },
    { key: "Others", value: "Others" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];

  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  //   const updateMasterStateArray = (attrName: any, value: any) => {
  //     const array_data = [...addCategoryStep];
  //     if (attrName[1] === "category_name") {
  //       array_data[attrName[0]].category_name = value;
  //     } else if (attrName[1] === "description") {
  //       array_data[attrName[0]].description = value;
  //     }

  //     setAddCategoryStep(array_data);
  //   };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-4">Raise Endorsement</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-3">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
          <Grid xs={12} className="mb-4 pt-0">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {pageStatus == 1 ? (
            <div>
              <Grid container spacing={2} className="mb-4">
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Client ID"
                    value={clientid}
                    attrName={setClientId}
                    value_update={updateMasterState}
                    dropdown_data={client_id_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Member ID"
                    value={employeeid}
                    attrName={setEmployeeId}
                    value_update={updateMasterState}
                    dropdown_data={employee_id_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Select Policy"
                    value={selectPolicy}
                    attrName={setSelectPolicy}
                    value_update={updateMasterState}
                    dropdown_data={policy_id_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Endorsement Value"
                    value={type}
                    attrName={setType}
                    value_update={updateMasterState}
                    dropdown_data={type_data}
                    warn_status={false}
                  />
                </Grid>
                {type === "Name" ||
                type === "Address" ||
                type === "Mobile Number" ||
                type === "Gender" ||
                type === "Email" ? (
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Endorsement Type"
                      value={endorsementType}
                      attrName={setEndorsementType}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                ) : null}
                {type === "Date of Birth" ? (
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Endorsement Type"
                      value={endorsementTypeOne}
                      attrName={setEndorsementTypeOne}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                ) : null}
              </Grid>

              {type === "Name" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12}>
                    <RKTextField
                      class_name="inputField"
                      title="Old Name"
                      value={employeename}
                      value_update={updateMasterState}
                      attrName={setEmployeeName}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={12}>
                    <h5 className="mb-0 font-sm">New Name</h5>
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="First Name"
                      value={employeenewname}
                      value_update={updateMasterState}
                      attrName={setEmployeeNewName}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Last Name"
                      value={employeelastname}
                      value_update={updateMasterState}
                      attrName={setEmployeeLastName}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              {type === "Address" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={12} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="Old Personal Address"
                      value={address}
                      value_update={updateMasterState}
                      attrName={setAddress}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={12}>
                    <h5 className="mb-0 font-sm">New Personal Address</h5>
                  </Grid>
                  <Grid xs={6} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="Building/Street Name"
                      value={employeenewaddress}
                      value_update={updateMasterState}
                      attrName={setEmployeeNewAddress}
                      warn_status={false}
                    />
                  </Grid>

                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Area Name"
                      value={areaName}
                      attrName={setAreaName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SearchDropdown
                      class_name="inputField"
                      title="Country"
                      value={country}
                      attrName={setCountry}
                      value_update={updateMasterState}
                      data={country_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SearchDropdown
                      class_name="inputField"
                      title="State"
                      value={State}
                      attrName={setState}
                      value_update={updateMasterState}
                      data={state_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SearchDropdown
                      class_name="inputField"
                      title="City"
                      value={City}
                      attrName={setCity}
                      value_update={updateMasterState}
                      data={city_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title={"Zipcode"}
                      value={Zipcode}
                      attrName={setZipcode}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              {type === "Mobile Number" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={6} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="Contact Number"
                      value={mobilenumber}
                      value_update={updateMasterState}
                      attrName={setMobileNumber}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="New Contact Number"
                      value={newmobilenumber}
                      value_update={updateMasterState}
                      attrName={setNewMobileNumber}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              {type === "Gender" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Old Gender"
                      value={gender}
                      attrName={setGender}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="New Gender"
                      value={newgender}
                      attrName={setNewGender}
                      value_update={updateMasterState}
                      dropdown_data={gender_data}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              {type === "Email" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={6} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="Current Email"
                      value={email}
                      value_update={updateMasterState}
                      attrName={setEmail}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6} className="inputField">
                    <RKTextField
                      class_name="inputField"
                      title="New Email"
                      value={newemail}
                      value_update={updateMasterState}
                      attrName={setNewEmail}
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              {type == "Date of Birth" ? (
                <Grid container spacing={2} className="mb-4">
                  <Grid xs={6} className="inputField">
                    <DatePicker
                      class_name="inputField"
                      title="Current Date of Birth"
                      value={Dob}
                      attrName={setDob}
                      value_update={updateMasterState}
                      error_message="Please enter Date of Birth"
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6} className="inputField">
                    <DatePicker
                      class_name="inputField"
                      title="New Date of Birth"
                      value={newDob}
                      attrName={setNewDob}
                      value_update={updateMasterState}
                      error_message="Please enter new Date of Birth"
                      warn_status={false}
                    />
                  </Grid>
                </Grid>
              ) : null}

              <Grid container spacing={3}>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Supporting Documents"
                    value={supportingDocument}
                    attrName={setSupportingDocument}
                    value_update={updateMasterState}
                    dropdown_data={supporting_document_data}
                    warn_status={false}
                  />
                </Grid>

                {supportingDocument === "Aadhar" ||
                supportingDocument === "PanCard" ||
                supportingDocument === "DrivingLiscense" ||
                supportingDocument === "Passport" ||
                supportingDocument === "Others" ? (
                  <>
                    <Grid
                      xs={10}
                      className="inputField uploadFile"
                      paddingRight={0}
                    >
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="textarea"
                        placeholder="Upload document"
                      />
                    </Grid>
                    <Grid xs={2} paddingLeft={0}>
                      <Button
                        variant="contained"
                        className="browsebtn"
                        component="label"
                      >
                        Browse
                        <input
                          hidden
                          accept="image/*"
                          multiple
                          type="file"
                          onChange={handleChange}
                        />
                      </Button>
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </div>
          ) : pageStatus == 2 ? (
            <Grid
              container
              spacing={2}
              sx={{
                displau: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              <Grid xs={12}>
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success text-center">
                  New request has been submitted successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
          {/* <Grid container spacing={2}>
            {pageStatus == 2 ? null : (
              <Grid
                xs={12}
                style={{ textAlign: "center", position: "relative" }}
                className="ctaBtn">
                <Button
                  variant="contained"
                  className="submitBtn"
                  onClick={() => {
                    changePageStatus(true);
                  }}>
                  {pageStatus == 1 ? "Submit" : "Continue"}
                </Button>

                {pageStatus == 1 ? null : (
                  <h5 className="steps">
                    {" "}
                    {pageStatus} <span>/1</span>{" "}
                  </h5>
                )}
              </Grid>
            )}
          </Grid> */}
        </div>
        {pageStatus !== 4 ? (
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setPageStatus(pageStatus + 1);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </SlidingPanel>
  );
};

export default AddNewRequest;
